import { render, staticRenderFns } from "./Send_notification.vue?vue&type=template&id=6ff5aa3e"
import script from "./Send_notification.vue?vue&type=script&lang=js"
export * from "./Send_notification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports